import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from '../hrmMessages';

const GlobalActionsButton = props => {
  const { intl, disabled, onInitCounter, inProgress } = props;

  return (
    <span className="tool-tip" data-toggle="tooltip" data-placement="top">
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled || inProgress}
        pullRight
        title={
          <span>
            {inProgress && <i className="fa fa-spinner fa-spin margin5R" />}
            <FormattedMessage {...messages.GlobalActions} />
          </span>
        }
      >
        <MenuItem onSelect={onInitCounter} id="global-actions-button-init">
          {intl.formatMessage(messages.InitializeCounter)}
        </MenuItem>
      </DropdownButton>
    </span>
  );
};

GlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onInitCounter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inProgress: PropTypes.bool,
};
GlobalActionsButton.defaultProps = { disabled: false, inProgress: false };
export default GlobalActionsButton;
